var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPriorityHigh = function SvgPriorityHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    fill: "none",
    viewBox: "0 0 12 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E53E3E",
    d: "m11.657 6.294-1.415 1.414L6 3.465 1.757 7.708.343 6.294 6 .637z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E53E3E",
    d: "m11.657 11.95-1.415 1.415L6 9.122l-4.243 4.243L.343 11.95 6 6.294z"
  })));
};
export default SvgPriorityHigh;